export const GET_INSTALLED_VEHICLE_BY_STATE = "GET_INSTALLED_VEHICLE_BY_STATE";
export const GET_ALERTS = "GET_ALERTS";
export const UPDATE_ALERT_STATUS = "UPDATE_ALERT_STATUS";
export const UPDATE_ALERT = "UPDATE_ALERT";
export const ADD_ALERT = "ADD_ALERT";
export const GET_ALERT_RULES_DROPDOWN = "GET_ALERT_RULES_DROPDOWN";
export const GET_ALERT_USERS = "GET_ALERT_USERS";
export const UPDATE_ALERT_USER_STATUS = "UPDATE_ALERT_USER_STATUS";
export const GET_ACCOUNTS_DROPDOWN = "GET_ACCOUNTS_DROPDOWN";
export const GET_MANUFACTURER_DROPDOWN = "GET_MANUFACTURER_DROPDOWN";
export const GET_RFC_DROPDOWN = "GET_RFC_DROPDOWN";
export const GET_USER_DROPDOWN = "GET_USER_DROPDOWN";
export const ADD_ALERT_USER = "ADD_ALERT_USER";
export const GET_NON_WORKING_SLOTS = "GET_NON_WORKING_SLOTS";
export const UPDATE_NON_WORKING_SLOT_STATUS = "UPDATE_NON_WORKING_SLOT_STATUS";
export const ADD_NON_WORKING_SLOT = "ADD_NON_WORKING_SLOT";
export const GET_NON_WORKING_SLOTS_VALIDITY = "GET_NON_WORKING_SLOTS_VALIDITY";
export const UPDATE_NON_WORKING_SLOT_VALIDITY_STATUS =
  "UPDATE_NON_WORKING_SLOT_VALIDITY_STATUS";
export const ADD_NON_WORKING_SLOT_VALIDITY = "ADD_NON_WORKING_SLOT_VALIDITY";
export const GET_NON_WORKING_SLOTS_VEHICLE = "GET_NON_WORKING_SLOTS_VEHICLE";
export const UPDATE_NON_WORKING_SLOT_VEHICLE_STATUS =
  "UPDATE_NON_WORKING_SLOT_VEHICLE_STATUS";
export const ADD_NON_WORKING_SLOT_VEHICLE = "ADD_NON_WORKING_SLOT_VEHICLE";
export const GET_ALERT_NOTIFICATION_TYPE_DROPDOWN =
  "GET_ALERT_NOTIFICATION_TYPE_DROPDOWN";
